// extracted by mini-css-extract-plugin
export default {"navbar-light":"footer_navbar-light__bJ8GL","navbar-toggler":"footer_navbar-toggler__VQD46","navbar-toggler-icon":"footer_navbar-toggler-icon__j5vvU","footer":"footer_footer__nqcHC"};